import { Uuid } from '@/api/types';
import { QuoteRejectReason } from '../case';

export enum Currency {
  USD = 'USD',
  EUR = 'EUR',
}

export type QuoteComment = {
  userId: Uuid;
  comment: string | null;
};

export enum QuoteStatus {
  NoQuote = 'NoQuote',
  Created = 'Created',
  Rejected = 'Rejected',
  ApprovedInternally = 'ApprovedInternally',
  RejectedInternally = 'RejectedInternally',
  SentToTXCenter = 'SentToTxCenter',
  ApprovedByTXCenter = 'ApprovedByTxCenter',
  RejectedByTXCenter = 'RejectedByTxCenter',
  InvoiceSent = 'InvoiceSent',
  InvoicePaid = 'InvoicePaid',
}

export type QuoteApproveInternallyBody = {
  groundQuotePriceInCents: number | null;
  airQuotePriceInCents: number | null;
  comment?: string;
  // Leave until final decision for this checkbox
  // excludeDryRunDiscount: boolean;
};

export type QuoteStatusChangeBody = {
  comment?: string;
  reason: QuoteRejectReason;
};

export type GroundQuote = {
  durationInSeconds: number;
  selfServicedDurationInSeconds: number;
  limitedPriceInCents: number;
  initPriceInCents: number;
  lightsAndSirensInCents: number | null;
};

export type AirQuote = {
  perBlockHourPriceInCents: number;
  routeTmdxDurationInSeconds: number;
  routeSplDurationInSeconds: number;
  benchmarkDurationInBlockSeconds: number;
  benchmarkDurationInFlightSeconds: number;
  supplementalLiftPriceInCents: number;
  initPriceInCents: number;
  finalPriceInCents: number;
};

export type RouteQuote = {
  id: string;
  caseId: string;
  groundQuote: GroundQuote;
  airQuote: AirQuote;
  currency: Currency;
  logistics: {
    logisticsId: string;
    version: number;
  };
};

export type RouteQuoteCustomer = {
  id: string;
  caseId: string;
  currency: Currency;
  totalAirPriceInCents: number;
  totalGroundPriceInCents: number;
};

export type QuoteTotalType = {
  quoteId: Uuid;
  caseId: Uuid;
  currency: Currency | null;
  totalInCents: number | null;
  totalGroundPriceInCents: number | null;
  totalAirPriceInCents: number | null;
};

export type QuoteTotalsResponse = {
  totalsByQuoteId: Record<string, QuoteTotalType>;
};
